import React, { Fragment, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import HeroImage from './HeroImage/HeroImage';
import ProductSpecifications from './ProductSpecifications/ProductSpecifications';
import PurchasingProcess from './PurchasingProcess/PurchasingProcess';
import Articles from './Articles/Articles';
import TermArticles from "./Articles/TermArticle";
import FAQs from './FAQs/FAQs';
import BeforeFooter from '../BeforeFooter/BeforeFooter';
import SolutionPanel from '../SolutionPanel/SolutionPanel';
import Marketing from './Marketing/Marketing';
import PermData from '../Helpers/Data/Products/Perm/PermData';
import FinalExpenseData from "../Helpers/Data/Products/FinalExpense/FinalExpenseData";
import TermData from '../Helpers/Data/Products/Term/TermData';
import TermInsuranceData from "../Helpers/Data/Products/TermInsurance/TermInsuranceData";
import DigitalTermData from '../Helpers/Data/Products/Term/DigitalTermData';
import EtradeTermData from '../Helpers/Data/Products/EtradeTerm/EtradeTermData';
import JuveData from '../Helpers/Data/Products/Juve/JuveData';
import LTCData from '../Helpers/Data/Products/LTC/LTCData';
import ProductInfo from '../Helpers/Data/Products/Americo/ProductInfo';
import DisabilityData from '../Helpers/Data/Products/Disability/DisabilityData';
import NaviData from '../Helpers/Data/Products/Navi/NaviData';
import SuppData from '../Helpers/Data/Products/Supplemental/SuppData';
import HospitalData from '../Helpers/Data/Products/Hospital/HospitalConfinment';
import LongTermDisabilityData from "../Helpers/Data/Products/LongTermDisability/LongTermDisabilityData";
import Reviews from './Reviews/Reviews';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';
import TermAbout from "../LandingPages/About/TermAbout";
import FinalExpenseAbout from "../LandingPages/About/FinalExpenseAbout";
import WholeLifeAbout from "../LandingPages/About/WholeLifeAbout";
import UniversalLifeAbout from "../LandingPages/About/UniversalLifeAbout";
import BusinessSolutionsAbout from "../LandingPages/About/BusinessSolutionsAbout";
import Carriers from "../Home/Carriers/Carriers";
import ProductPolicyCost from "./ProductPolicyCost/ProductPolicyCost";
import TermPurchasing from "./PurchasingProcess/TermPurchasingProcess";
import FinalExpensePurchasing from "./PurchasingProcess/FinalExpensePurchasingProcess";
import WholeLifePurchasing from "./PurchasingProcess/WholeLifePurchasingProcess";
import WholeLifeData from "../Helpers/Data/Products/WholeLife/WholeLifeData";
import UniversalLifePurchasing from "./PurchasingProcess/UniversalLifePurchasingProcess";
import LoanProtectionData from "../Helpers/Data/Products/LoanProtection/LoanProtectionData";
import LoanProtectionPurchasing from "./PurchasingProcess/LoanProtectionPurchasingProcess";
import LoanProtectionAbout from "../LandingPages/About/LoanProtectionAbout";
import GetProductDetail from "../Common/GetProductDetail";
import PropTypes from 'prop-types';
import UniversalLifeData from "../Helpers/Data/Products/UniversalLife/UniversalLifeData";
import BusinessSolutionsData from "../Helpers/Data/Products/BusinessSolutions/BusinessSolutionsData";
import BusinessSolutionsPurchasing from "./PurchasingProcess/BusinessSolutionsPurchasingProcess";
import Products from "./Products/Products";
import SolutionArticleSummary from "./SolutionsArticleSummary/SolutionArticleSummary";
import SolutionArticleDetail from "./SolutionsArticleDetail/SolutionArticleDetail";
import Statistics from "./Statistics/Statistics";
import './ProductLandingPage.scss';

export default function ProductLandingPage(props) {

  const [heroImageUrl, setHeroImageUrl] = useState(null);
  const [heroImageTabletUrl, setHeroImageTabletUrl] = useState(null);
  const [heroImageMobileUrl, setHeroImageMobileUrl] = useState(null);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const scrollToElement = (anchor) => {
    if (anchor) {
      const element = document.getElementById(anchor);
      const y = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({top: y, behavior: "smooth"});
    }
  }

  let data;
  let product = props.match.params.product;

  //workaround for Haven's wrong landing url
  const url = window.location.href;
  if (url.includes("digital-term")) {
    product = "digital-term";
  };

  const isTermInsurance = product === 'term-insurance';
  const isFinalExpense = product === 'final-expense';
  const isWholeLife = product === 'whole-life';
  const isUniversalLife = product === 'universal-life';
  const isLoanProtection = product === 'loan-protection';
  const isBusinessSolutions = product === 'business-solutions';
  const isPermProduct = product === 'permanent';
  const isJuviProduct = product === 'children';

  useEffect(() => {
    window.scrollTo(0, 0);
    const account = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    const accountProductTypeSettings = account.accountProducts.find(product => product.productLandingUrl === props.location.pathname);
    const accountLandingOverride = account.accountOverrides && accountProductTypeSettings ? 
      account.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;

    setHeroImageUrl(
      accountLandingOverride &&
      (accountProductTypeSettings ? accountProductTypeSettings.productTypeId === accountLandingOverride.accountProductTypeId
        : null) && accountLandingOverride.landingHeroImageUrl ? accountLandingOverride.landingHeroImageUrl :
      (accountProductTypeSettings && accountProductTypeSettings.heroImageUrl) || `/product-landing/${product.substring(0, 4)}/hero-image.jpg`);
    setHeroImageTabletUrl(
      accountLandingOverride &&
      (accountProductTypeSettings ? accountProductTypeSettings.productTypeId === accountLandingOverride.accountProductTypeId
        : null) && accountLandingOverride.landingHeroImageTabletUrl ? accountLandingOverride.landingHeroImageTabletUrl :
      (accountProductTypeSettings && accountProductTypeSettings.heroImageTabletUrl) || `/product-landing/${product.substring(0, 4)}/hero-tab-image.jpg`);
    setHeroImageMobileUrl(
      accountLandingOverride &&
      (accountProductTypeSettings ? accountProductTypeSettings.productTypeId === accountLandingOverride.accountProductTypeId
        : null) && accountLandingOverride.landingHeroImageMobileUrl ? accountLandingOverride.landingHeroImageMobileUrl :
      (accountProductTypeSettings && accountProductTypeSettings.heroImageMobileUrl) || `/product-landing/${product.substring(0, 4)}/hero-small.jpg`);
  }, []);

  switch (product) {
    case "permanent":
      data = PermData();
      break;
    case "whole-life": 
      data = WholeLifeData({ history: props.history, isWholeLife: isWholeLife });
      break;
    case "universal-life":
      data = UniversalLifeData({ history: props.history, isUniversalLife: isUniversalLife });
      break;
    case "term":
      let productDetail = GetProductDetail(['/landing/term', '/quote/term-life-insurance/multi-carrier-term']);
      if (productDetail === undefined) {
        productDetail = GetProductDetail(['/landing/term-insurance', '/term-insurance']);
        const redirectPath = productDetail === undefined ? '/' : '/landing/term-insurance';
        window.location = redirectPath;
      }
      else {
        data = TermData({ history: props.history });
      }
      break;
    case "term-insurance":
      productDetail = GetProductDetail(['/landing/term-insurance', '/term-insurance']);
      if (productDetail === undefined) {
        window.location = '/';
      }
      data = TermInsuranceData({ history: props.history, isTermInsurance: isTermInsurance });
      break;
    case "final-expense":
      data = FinalExpenseData({ history: props.history, isFinalExpense: isFinalExpense });
      break;
    case "business-solutions":
      data = BusinessSolutionsData({ history: props.history, isBusinessSolutions: isBusinessSolutions });
      break;
    case "children":
      data = JuveData();
      break;
    case "long-term-care":
      data = LTCData();
      break;
    case "loan-protector":
      productDetail = GetProductDetail(['/landing/loan-protection', '/loan-protection']);
      const redirectPath = productDetail === undefined ? '/' : '/landing/loan-protection';
      window.location = redirectPath;
      data = ProductInfo();
      break;
    case "loan-protection":
      data = LoanProtectionData({ history: props.history, isLoanProtection: isLoanProtection });
      break;
    case "disability-income":
      data = DisabilityData();
      break;
    case "navigating-medicare":
      data = NaviData();
      break;
    case "supplemental":
      data = SuppData();
      break;
    case "hospital":
      data = HospitalData();
      break;
    case "term-s":
    case "etrade-term":
      data = EtradeTermData({ history: props.history });
      break;
    case "digital-term":
      productDetail = GetProductDetail(['/landing/digital-term', '/landing/term/digital-term' ]);
      if (productDetail === undefined) {
        productDetail = GetProductDetail(['/landing/term-insurance', '/term-insurance']);
        const redirectPath = productDetail === undefined ? '/' : '/landing/term-insurance';
        window.location = redirectPath;
      }
      else {
        data = DigitalTermData();
        break;
      }
    case "income-long-term-disability":
      data = LongTermDisabilityData({ history: props.history });
      break;
    default:
      window.location = "/not-found";
  };

  return (
    <Container fluid className={product === "term" ? 'term-landing product-landing' : 'product-landing'}>
      <Helmet>
        <title>{data.name}</title>
      </Helmet>
      <HeroImage
        title={data.name}
        subtitle={data.subtitle}
        subtitleExtended={data.subtitleExtended}
        heroText={data.heroText}
        about={data.about}
        heroImageUrl={heroImageUrl}
        heroImageTabletUrl={heroImageTabletUrl}
        heroImageMobileUrl={heroImageMobileUrl}
        hasQuickQuoteDisclaimer={data.hasQuickQuoteDisclaimer}
        form={!isBusinessSolutions ? data.basicInfoForm(props.history) : null}
        isTermInsurance={isTermInsurance}
        isFinalExpense={isFinalExpense}
        isWholeLife={isWholeLife}
        isUniversalLife={isUniversalLife}
        isLoanProtection={isLoanProtection}
        isBusinessSolutions={isBusinessSolutions}
        />
      {isTermInsurance && <Carriers carrierVerbiage = "We shop top-rated carriers to find you the best value" />} 
      {(isFinalExpense || isWholeLife || isUniversalLife) && <Carriers productCarriers={data.productCarriers} carrierVerbiage = "We shop top-rated carriers to find you the best value" />} 
      {isTermInsurance && <TermAbout data={data.about}/>}
      {isFinalExpense && <FinalExpenseAbout data={data.about}/>}
      {isWholeLife && <WholeLifeAbout data={data.about}/>}
      {isUniversalLife && <UniversalLifeAbout data={data.about} carriers={data.productCarriers}/>}
      {isLoanProtection && <LoanProtectionAbout data={data.about} />}
      {isBusinessSolutions && <BusinessSolutionsAbout data={data.about} />}
      {(!isTermInsurance && !isFinalExpense && !isWholeLife && !isUniversalLife && !isLoanProtection && !isBusinessSolutions) && data.productSpecifications && !data.hideMarketing &&
        <ProductSpecifications data={data.productSpecifications} coverageAmount={data.specs.coverageAmount} />
      }

      {isBusinessSolutions && 
        <Fragment>
          <Products data={data.productData} journeys={data.availableProductJourneys} />
          <SolutionArticleSummary data={data.termArticle} scrollToElement={scrollToElement}/>
        </Fragment>
      }

      {(!isTermInsurance || !isFinalExpense || !isWholeLife || !isUniversalLife || !isLoanProtection || !isBusinessSolutions) && data.marketing && !data.hideMarketing && <Marketing data={data.marketing}/>}
      {isTermInsurance && <TermPurchasing data={data.purchasingProcess}/>}
      {isFinalExpense && <FinalExpensePurchasing data={data.purchasingProcess}/>}
      {isWholeLife && <WholeLifePurchasing data={data.purchasingProcess}/>}
      {isUniversalLife && <UniversalLifePurchasing data={data.purchasingProcess}/>}
      {isLoanProtection && <LoanProtectionPurchasing data={data.purchasingProcess} />}
      {isBusinessSolutions && <BusinessSolutionsPurchasing data={data.purchasingProcess} journeys={data.availableProductJourneys} />}

      {isWholeLife && <SolutionPanel data={data.solutionPanel} href={data.solutionPanel.href}/>}

      {(!isTermInsurance && !isFinalExpense && !isWholeLife && !isUniversalLife && !isLoanProtection && !isBusinessSolutions) && data.purchasingProcess && !data.hideMarketing && <PurchasingProcess data={data.purchasingProcess}/>}
      {(isTermInsurance || isFinalExpense || isWholeLife || isUniversalLife || isLoanProtection) && <ProductPolicyCost data={data.policyCost} location={props.location} action={scrollToTop} />}
      {(!isTermInsurance || !isFinalExpense || !isWholeLife || !isUniversalLife || !isLoanProtection) && data.articleKeys && !data.hideMarketing &&
        <Articles articleKeys={data.articleKeys} title={data.articleTitle} videoData={product === "term" ? data.productSpecifications.video : null} />
      }

      {isBusinessSolutions && 
      <Fragment>
        <Statistics data={data.statistics} />
        <SolutionArticleDetail data={data.termDetailArticle} journeys={data.availableProductJourneys} />
      </Fragment>
      }

      {data.faq && !data.hideMarketing &&
        <FAQs 
          data={data.faq} 
          isTermInsuranceProduct={isTermInsurance}
          isFinalExpenseProduct={isFinalExpense}
          isWholeLifeProduct={isWholeLife}
          isUniversalLifeProduct={isUniversalLife}
          isLoanProtectionProduct={isLoanProtection}
          isBusinessSolutions={isBusinessSolutions}
          isPermProduct={isPermProduct}
          isJuviProduct={isJuviProduct}
          isAddDefaultFaq={data.isAddDefaultFaq !== undefined ? data.isAddDefaultFaq : true} />
      }
      {(isTermInsurance || isFinalExpense || isWholeLife || isUniversalLife || isLoanProtection) && <TermArticles data={data.termArticle}/>}

      {data.showRating && !data.hideMarketing &&
        <Reviews data={data.Review} />
      }

      {data.footerMessage && !data.hideMarketing && <BeforeFooter title={data.footerMessage} action={scrollToTop} isModernized={(isTermInsurance || isFinalExpense || isWholeLife || isUniversalLife || isLoanProtection || isBusinessSolutions) ? true : false} buttonLabel={data.footerButtonName ? data.footerButtonName : "GET A QUOTE"} journeys={data.availableProductJourneys} />}
    </Container>

  );
};

ProductLandingPage.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/LandingPages/ProductLandingPage.js